import { Menu } from '@mantine/core';
import { Icon } from '@repo/foundations';
import { type SecodaEntity } from '../../../../lib/models';
import { closeAllModals, openModal } from '../../../ModalManager';

import { EntityType } from '@repo/common/enums/entityType';
import type { ISecodaEntity } from '../../../../api';
import { DataAccessRequestCreateModal } from '../../../DataAccessRequest/DataAccessRequestCreateModal/DataAccessRequestCreateModal';

interface RequestAccessActionProps {
	entity: SecodaEntity | ISecodaEntity;
}

function getResourceLevel(
	entity: SecodaEntity | ISecodaEntity
): 'database' | 'schema' | 'table' {
	if (entity.entity_type === EntityType.table) return 'table';
	if (entity.entity_type === EntityType.schema) return 'schema';
	return 'database';
}

export function RequestAccessAction({ entity }: RequestAccessActionProps) {
	const handleOpenModal = () => {
		const resourceLevel = getResourceLevel(entity);
		openModal({
			title: 'Request access',
			size: 480,
			centered: true,
			children: (
				<DataAccessRequestCreateModal
					onClose={closeAllModals}
					request={{
						integration_id: entity.integration,
						requested_resources: [
							{
								id: entity.id,
								database_name:
									resourceLevel === 'database'
										? entity.title
										: entity.search_metadata?.database,
								schema_name:
									resourceLevel === 'schema'
										? entity.title
										: entity.search_metadata?.schema,
								table_name:
									resourceLevel === 'table'
										? entity.title
										: entity.search_metadata?.table,
								resource_level: resourceLevel,
							},
						],
					}}
					withIntegrationSelector={false}
					withResourcesSelector={false}
				/>
			),
		});
	};

	return (
		<Menu.Item icon={<Icon name="edit" />} onClick={handleOpenModal}>
			Request access
		</Menu.Item>
	);
}
